
import orderList from './orderList';
import Sticky from 'vux/src/components/sticky/index.vue'

export default {
components: {
orderList,
Sticky
},
data() {
return {
addressDesc: '',
carBadge: {
receivWaiting: 0,
shipWaiting: 0,
payWaiting: 0,
afterSale: 0
},
activeIndex: 0,
tabItem: [
{
title: '全部订单'
},
{
title: '待付款'
},
{
title: '待发货'
},
{
title: '待收货'
}
],
orderReset: true
};
},
computed: {
token() {
return this.$store.state.token;
},
userInfo: {
get() {
return this.$store.state.userInfo;
},
set(value) {
this.$store.state.userInfo = value;
}
}
},
watch: {
activeIndex(val) {
this.$router.replace('/mallMine?index=' + val);
},
token(newVal) {
if (newVal) {
this.getAddress();
this.getOrderNum();
} else {
this.carBadge = {
receivWaiting: 0,
shipWaiting: 0,
payWaiting: 0,
afterSale: 0
};
}
}
},
methods: {
getAddress() {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/receiverAddress', {
params: {
shopperId: that.$store.state.userInfo.shopperId
}
})
.then(function(res) {
if (res.status == 200) {
var flag = false;
that.addressList = res.body.map(item => {
item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
return item;
});

res.body.forEach(item => {

if (item.defaultAddress == 1) {
item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
that.addressDesc = item.desc;
flag = true;
}
});
if (!flag && res.body.length > 0) {

var one = res.body[0];
one.desc = one.regionDesc.replace(/\s/g, '') + one.address;
that.addressDesc = one.desc;
flag = true;
}
if (!flag) {
that.address = null;
}
}
});
},

getOrderNum() {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/orderNum', {
params: {
shopperId: that.userInfo.shopperId
}
})
.then(function(response) {
if (response.status == 200) {

that.carBadge = response.body;
}
});
},

switchOrderStatus(index_) {
this.orderReset = false;
this.$nextTick(() => {
this.orderReset = true;
this.activeIndex = index_;
});
},
toPersonalSettings(code) {
this.$router.push('/mallPersonalSettings?code=' + code);
},
toOrderDetail() {
this.$router.push('/mallOrderDetail');
},

logout() {
let that = this;
that.$vux.confirm.show({
content: `是否确认退出登录？`,
cancelText: '取消',
confirmText: '确认',
title: '提示',
onConfirm() {
that.$store.state.token = null;
that.$store.state.userInfo = that.userInfo = {
poster: '',
displayName: ''
};




that.$store.state.APPPAGE.resetWebsocket();
that.$router.push('/mallGoods');
that.$store.state.APPPAGE.toLoginFunc();
}
});
}
},
mounted() {
this.getAddress();
this.getOrderNum();
this.$nextTick(() => {
this.activeIndex = parseInt(this.$route.query.index ? this.$route.query.index : 0);
});
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/index.vue